import type {
	DialogProps as AriaDialogProps,
	ModalOverlayProps as AriaModalOverlayProps,
} from "react-aria-components";

import {
	Dialog as AriaDialog,
	DialogTrigger as AriaDialogTrigger,
	Modal as AriaModal,
	ModalOverlay as AriaModalOverlay,
} from "react-aria-components";

import { cx } from "@/utils/cx";

export const DialogTrigger = AriaDialogTrigger;

export const ModalOverlay = (props: AriaModalOverlayProps) => {
	return (
		<AriaModalOverlay
			{...props}
			className={(state) =>
				cx(
					"fixed inset-0 z-50 flex h-[100dvh] w-full items-end justify-center overflow-hidden bg-overlay/70 outline-hidden backdrop-blur-[6px] max-sm:h-[100dvh] max-sm:p-0 sm:h-dvh sm:items-center sm:justify-center sm:p-8",
					state.isEntering && "duration-300 ease-out animate-in fade-in",
					state.isExiting && "duration-200 ease-in animate-out fade-out",
					typeof props.className === "function"
						? props.className(state)
						: props.className,
				)
			}
		/>
	);
};

export const Modal = (props: AriaModalOverlayProps) => (
	<AriaModal
		{...props}
		className={(state) =>
			cx(
				"pointer-events-none flex h-full max-h-full min-h-0 w-full align-middle outline-hidden max-sm:h-full max-sm:max-h-full max-sm:rounded-none sm:h-auto sm:rounded-xl",
				state.isEntering && "duration-300 ease-out animate-in zoom-in-95",
				state.isExiting && "duration-200 ease-in animate-out zoom-out-95",
				typeof props.className === "function"
					? props.className(state)
					: props.className,
			)
		}
	/>
);

export const Dialog = (props: AriaDialogProps) => (
	<AriaDialog
		{...props}
		className={cx(
			"pointer-events-none flex h-full min-h-screen w-full flex-col items-center justify-center outline-hidden max-sm:h-full max-sm:items-stretch sm:min-h-0",
			props.className,
		)}
	/>
);
